import ActionButton from 'components/ActionButton';
import React, { useEffect, useState } from 'react';
import styles from './index.module.scss';
import qs from 'query-string';
import { PO_STATUS, sortArray } from 'utils';
import SupplierAutosuggest from 'components/SupplierAutosuggest';

const Filter = props => {
  const { match: { path }} = props;
  const [poId, setPOId] = useState<string>('');
  const [supplierId, setSupplierId] = useState<string>('');
  const [status, setStatus] = useState<string>('');
  const [supplier, setSupplier] = useState<Record<string, any>>({});
  const isSupplierPage = (path ==='/suppliers/:supplierId');

  useEffect(() => {
    if(!isSupplierPage){
      const {
        poId,
        status,
        supplierId,
      } = qs.parse(props.location.search, { parseBooleans: true, parseNumbers: true });
  
      setPOId(poId?.toString() || '');
      setStatus(status?.toString() || '');
      setSupplierId(supplierId?.toString() || '');
    }
  }, []);

  const resetFilter = () => {
    setPOId('');
    setStatus('');
    setSupplierId('');
    setSupplier({});
    const filterData = {
      poId: '',
      status: '',
      supplierId: '',
    };
    props.onSubmit(filterData);
  };

  const handleSubmit = () => {
    const filterData = {
      poId,
      status,
      supplierId,
    };
    props.onSubmit(filterData);
  };

  const StatusDropdown = () => {
    const getOptions = () => {
      const keys = Object.keys(PO_STATUS);
      return sortArray(keys).map((key, i) =>
        <option key={i} value={PO_STATUS[key]}>{PO_STATUS[key]}</option>,
      );
    };
    
    return (
      <div className={styles['input-group']}>
        <div className={styles['label']}>Status</div>
        <select
          value={status}
          className={'form-control'}
          onChange={e => setStatus(e.target.value)}
        >
          <option hidden={!!status} value={'default'}>Select a status</option>
          {getOptions()}
        </select>
      </div>
    );
  };
  
  return (
    <form className={styles['filter-container']} onSubmit={handleSubmit}>
      <div className={styles['input-group']}>
        <div className={styles['label']}>Purchase Order ID</div>
        <input
          value={poId}
          onChange={e => setPOId(e.target.value)}
          className={'form-control'}
        />
      </div>
      <StatusDropdown />
      {!isSupplierPage && 
        <div className={styles['autosuggest-group']}>
          <div className={styles['label']}>Supplier ID</div>
          <SupplierAutosuggest
            supplierName={supplier.full_name || ''}
            // eslint-disable-next-line @typescript-eslint/camelcase
            setSupplierName={val => setSupplier({ ...supplier, full_name: val  })}
            setSupplier={setSupplier}
            setSupplierId={setSupplierId}
          />
        </div>
      }
      <div className={styles['buttons-container']}>
        <ActionButton
          text={'Reset'}
          active={true}
          isLoading={false}
          onClick={resetFilter}
        />
        <ActionButton
          text={'Submit'}
          active={true}
          isSubmit={true}
          isLoading={false}
          onClick={handleSubmit}
        />
      </div>
    </form>
  );
};

export default Filter;